import React, { useEffect, useMemo, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Await, defer, useLoaderData, useNavigate } from 'react-router-dom';
import { addGroup, getGroups, listPartneredArcs } from '../../Api Methods/Api';
import GroupsGrid from './GroupsGrid';
import Button1 from '../../components/UI/Button/Button1';
import Modal from '../../components/Modal/Modal';
import InputForm from '../../components/forms/InputFormCreateGroup';
import DataManager from '../../hooks/DataManager';
import StatCard from '../../components/UI/Stats/StatCard';
import DeviceLoadingGrid from '../../components/GridList/DeviceLoadingGrid';
import classes from './GroupsGrid.module.css'
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import areYouSureAnim from '../../assets/animations/areYouSure.json'
import { serviceActions } from '../../store/service-Slice';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Lottie from 'lottie-react';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
import { Divider } from 'primereact/divider';
import { Checkbox } from 'primereact/checkbox';
import mixpanel from 'mixpanel-browser';


const Groups = () => {
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);
  const role = useSelector(state => state.auth.role);
  const companyName = useSelector(state => state.auth.companyName);
  const [title, setTitle] = useState("Create group");

  const cachedGroups = useSelector(state => state.service.GroupsTableData);
  const [groups, setGroups]  = useState(cachedGroups);
  const myGroup = Array.isArray(groups) ? groups.find(g => g.name === companyName) : null;
  console.log(myGroup);
  const visibleGroups = Array.isArray(groups) ? groups.filter(g => g.name !== companyName) : groups;
  const isEyeSpyFX = companyName === "EyeSpyFX";
  const groupCreationEnabled = myGroup?.allowGroupCreation === 1;
  const showMonitoringStation = myGroup?.supportsMonitoring === 1;
  const billingEnabled = myGroup?.billingEnabled;
  const [modalComponent, setModalComponent] = useState();
  const [name, setName] = useState('')
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedMonitoringStation, setSelectedMonitoringStation] = useState(null);
  const [monitoringStationOptions, setMonitoringStationOptions] = useState([]);
  const [update, setUpdate] = useState(0);
  const [isCreateGroupVisible, setIsCreateGroupVisible] = useState(false)
  const [successVisible, setSuccessVisible] = useState(false)
  const [failVisible, setFailVisible] = useState(false)
  const [failMessage, setFailMessage] = useState("")
  const [confirmVisible, setConfirmVisible] = useState(false)

  const [newGroupSupportEnabled, setNewGroupSupportEnabled] = useState(false)
  const [newGroupAllowSiteCreation, setNewGroupAllowSiteCreation] = useState(false)
  const [newGroupBillingEnabled, setNewGroupBillingEnabled] = useState(billingEnabled)
  const [newGroupAllowGroupCreation, setNewGroupAllowGroupCreation] = useState(false)
  const [newGroupIsOnDD, setNewGroupIsOnDD] = useState(false)
  const [newGroupIsBillableAccount, setNewGroupIsBillableAccount] = useState(false)
  const [newGroupIsWhitelabel, setNewGroupIsWhitelabel] = useState(false)
  const [newGroupUserInvitesEnabled, setNewGroupUserInvitesEnabled] = useState(false)
  const [newGroupObject, setNewGroupObject] = useState({})
  
  const [isLoading, setIsLoadng] = useState(() => {
    return !cachedGroups || cachedGroups.length === 0;
  });    
  const [isLoadingStats, setIsLoadingStats] = useState(true)

  const dataManager = new DataManager();
  const navigate = useNavigate();

  const apiData = {
    token,
    client
  }

  useEffect(() => {
  }, [selectedGroup])

  useEffect(() => {
  }, [name])

  const dispatch = useDispatch();

  const HandleGetGroups = async () => {
    const data = await getGroups(apiData, dispatch)
    const sortedData = data.sort((a, b) => a.name.localeCompare(b.name))
    setGroups(sortedData)
    dispatch(serviceActions.setGroupsTableData(sortedData));
    

    setIsLoadng(false)
    setIsLoadingStats(false)
    localStorage.setItem('groups', JSON.stringify(data));
  }

  useEffect(() => {
    HandleGetGroups()

    mixpanel.track("Groups tab visited", {
      user: localStorage.getItem('email')
    })
  }, [update])

  useEffect(() => {
    const loadArcs = async () => {
      const response = await listPartneredArcs(apiData, dispatch)
      if (response?.data) {
        const options = [
          { id: 0, name: 'Self monitored' },
          ...response.data.filter(arc => arc.name !== "Monitor Test" && arc.name !== "Monitor Test 2" && arc.platform === 'sentinel')
        ]
        setMonitoringStationOptions(options)
      }
    }
    loadArcs()
  }, [])

  const ModalDialog = useRef();

  // const handleCreateGroups = () => {
  //   setModalComponent(
  //     <div>
  //     <br/>
  //         <InputForm label={"Enter name of group"} setName={setName}></InputForm>
       
  //       <div>

  //       <Dropdown
  //           value={selectedGroup}
  //           className="w-full md:w-14rem"
  //           style={{ width: '300px' }}  
  //           onChange={(e) => setSelectedGroup(e.value)}
  //           options={groups}
  //           optionLabel="name"
  //           placeholder="Choose group"
  //           filter                 
  //           filterPlaceholder="Search groups..."
  //       />

  //         {/*<Dropdown label={"Please select the parent group below"} dropDownOptions={groupNames} setSelectedGroup={setSelectedGroup} />*/}
  //       </div>
  //       <br></br>
  //       <Button1 onClick={createGroup}>Create</Button1>
  //     </div>
  //   )  
  //   HandleShowModal();
  // }

  const showError = (message) => {
    setModalComponent(
      <div>
        <div>
          <h3>Error</h3>
        </div>
        <br></br>
        <div>
         <p>Error creating group, please try again later.</p>
         <p>{message}</p>
        </div>
        <br></br>
          <Button  icon="pi pi-times" onClick={HandleCloseModal} label="Close" severity='secondary'/>
      </div>
    )  
    HandleShowModal();
  }

  const resetCreateGroupForm = () => {
    setName('')
    setSelectedGroup(null)
    setSelectedMonitoringStation(null)
    setNewGroupSupportEnabled(false)
    setNewGroupAllowSiteCreation(false)
    setNewGroupBillingEnabled(false)
    setNewGroupAllowGroupCreation(false)
    setNewGroupIsOnDD(false)
    setNewGroupUserInvitesEnabled(false)
  }

  const createGroup = async () => {
    const body = {
      groupName: name,
      parentID: selectedGroup.id,
      defaultMonitoredByID: selectedMonitoringStation?.id ?? null,
      supportEnabled: newGroupSupportEnabled ? 1 : 0,
      allowSiteCreation: newGroupAllowSiteCreation ? 1 : 0,
      billingEnabled: newGroupBillingEnabled ? 1 : 0, //issue here default needs to be the group youre logged in as
      allowGroupCreation: newGroupAllowGroupCreation ? 1 : 0,
      isOnDD: newGroupIsOnDD ? 1 : 0,
      isBillableAccount: newGroupIsBillableAccount ? 1 : 0,
      isWhitelabelCustomer: newGroupIsWhitelabel ? 1 : 0,
      userInvitesEnabled: newGroupUserInvitesEnabled ? 1 : 0,
    }

    if (name !== '' && selectedGroup !== ''){
      const response = await addGroup(apiData, body, dispatch)
      if (response.success){
          HandleCloseModal();
          setSuccessVisible(true)
          setIsCreateGroupVisible(false)
          resetCreateGroupForm()
      } else {
        setFailMessage(response.msg)
      }
    } else {
      //invalid form
    }
  }

  useEffect(() => {
    if (failMessage !== "") {
      setFailVisible(true)
    }
  }, [failMessage])

  const HandleShowModal = () => {
    ModalDialog.current.open();
  };

  const HandleCloseModal = () => {
    ModalDialog.current.close();
    setTitle("Create group")
  };

  const handleInputChange = (e) => {
    setName(e.target.value);

    /*const timer = setTimeout(() => {
      if (name && (e.target.value !== name)) {
        mixpanel.track("Groups name creation performed", {
            user: localStorage.getItem('email'),
            groupName: e.target.value
        });
      }
    }, 2000);
    return () => clearTimeout(timer);*/
  };

  const navigateToCreatedGroup = async () => {
    const newGroups = await getGroups(apiData, dispatch)
    console.log(newGroups);
    if (newGroups.length > 0) {
        localStorage.setItem('groups', JSON.stringify(newGroups));
        sessionStorage.setItem('groupClicked', newGroupObject.groupName)   
        sessionStorage.setItem('groupPath', newGroupObject.groupPath)
        sessionStorage.setItem('groupClickedID', newGroupObject.groupID)   
        navigate(`/Dashboard/Groups/GroupSites/`)
    }    
  }

  return ( 
    <>
      <Modal ref={ModalDialog} title={"Create group"} modalName={""} HandleShowModal={HandleShowModal}>
          {modalComponent}
      </Modal>


      <Dialog
          header="Create group"
          visible={isCreateGroupVisible}
          style={{ width: "40vw" }}
          onHide={() => { setIsCreateGroupVisible(false); resetCreateGroupForm(); }}
          >
          <div>
           <FloatLabel>
              <InputText
                  value={name}
                  onChange={handleInputChange}
              />
              <label htmlFor="ruleName">Name</label>
          </FloatLabel>
          <small>Please note group names must be unique and cannot be changed later</small>

          <Divider type="solid"/>

          <p>Choose the parent group from the dropdown below</p>
              <Dropdown
              value={selectedGroup}
              onChange={(e) => setSelectedGroup(e.value)}
              options={groups}
              optionLabel="name"
              showClear
              filter
              placeholder="Select a group"
              className="w-full md:w-14rem" />

          {showMonitoringStation && (<>
          <Divider type="solid"/>

          <p>Choose the monitoring station from the dropdown below</p>
              <Dropdown
              value={selectedMonitoringStation}
              onChange={(e) => setSelectedMonitoringStation(e.value)}
              options={monitoringStationOptions}
              optionLabel="name"
              showClear
              filter
              placeholder="Select a monitoring station"
              className="w-full md:w-14rem" />
          </>)}

          {(() => {
              const availablePerms = [
                  { key: "supportEnabled",     label: "Enable Inniovate ticket creation",       checked: newGroupSupportEnabled,     set: setNewGroupSupportEnabled },
                  { key: "allowSiteCreation",  label: "Allow site creation",  checked: newGroupAllowSiteCreation,  set: setNewGroupAllowSiteCreation },
                  { key: "allowGroupCreation", label: "Allow group creation", checked: newGroupAllowGroupCreation, set: setNewGroupAllowGroupCreation },
                  { key: "billingEnabled",     label: "Enable billing",       checked: newGroupBillingEnabled,     set: setNewGroupBillingEnabled,     eyespyfxOnly: true },
                  { key: "isOnDD",             label: "Is on Direct Debit",   checked: newGroupIsOnDD,             set: setNewGroupIsOnDD,             eyespyfxOnly: true },
                  { key: "isBillableAccount",  label: "Is billable account",   checked: newGroupIsBillableAccount,  set: setNewGroupIsBillableAccount,  eyespyfxOnly: true },
                  { key: "isWhitelabelCustomer", label: "Whitelabel customer",  checked: newGroupIsWhitelabel,       set: setNewGroupIsWhitelabel,       eyespyfxOnly: true },
                  { key: "userInvitesEnabled", label: "User invites enabled",  checked: newGroupUserInvitesEnabled, set: setNewGroupUserInvitesEnabled },
              ].filter(p => myGroup?.[p.key] === 1 && (!p.eyespyfxOnly || isEyeSpyFX));
              if (availablePerms.length === 0) return null;
              return (
                  <>
                      <Divider type="solid"/>
                      <p>Permissions</p>
                      <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                          {availablePerms.map(({ key, label, checked, set }) => (
                              <div key={key} style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}>
                                  <Checkbox inputId={key} checked={checked} onChange={e => set(e.checked)} />
                                  <label htmlFor={key} style={{ fontSize: "14px", color: "#4a4a4a", cursor: "pointer", userSelect: "none" }}>{label}</label>
                              </div>
                          ))}
                      </div>
                  </>
              );
          })()}

          </div>

          <br></br>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button icon="pi pi-check" label="Create group" severity="success" disabled={!selectedGroup} onClick={createGroup} />
          </div>
      </Dialog>

        <Dialog
            header="Success"
            visible={successVisible}
            style={{ width: "40vw" }}
            onHide={() => { setSuccessVisible(false); window.location.reload(); }}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br />
                <br />
                <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>Group created successfully!</h3>
                    <br />
                    <p style={{ textAlign: "center", color: "#858585" }}>Page will reload for changes to take effect</p>
                </div>
                <br />
                <br />
                <div>
                    <Button icon="pi pi-times" label="Close" severity="secondary" onClick={() => { setSuccessVisible(false); window.location.reload(); }} />
                </div>
            </div>
        </Dialog>

        <Dialog
            header="Something went wrong"
            visible={failVisible}
            style={{ width: "40vw" }}
            onHide={() => setFailVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={failAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br/>
                <h3 style={{color:"#6e6e6eff"}}>{failMessage}</h3>
                <br></br>
                <Button  icon="pi pi-times" label="Close" rounded severity="secondary" onClick={() => setFailVisible(false)}/>
            </div>
        </Dialog>

        
      <Await resolve={groups}>
        {(loadedTotalGroups) => 
          <div style={{ display: "flex",  maxWidth:"290px", minWidth:"250px" , alignSelf:"flex-start", alignContent:"start", alignContent:"flex-start"}}>
            {groups && <StatCard title={"Total groups"} value={visibleGroups?.length} isLoading={isLoading} />}
          </div>
        }
      </Await>
              

      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "30px", marginTop:"15px"}}>
          {(role === "admin" || role === "TechSupport") && groupCreationEnabled && (
            <Button severity="success" label="Create new group" style={{fontSize: "14px", padding:10}} icon="pi pi-plus" onClick={() => setIsCreateGroupVisible(true)}/>
          )}
        </div>

        {groups ? (
          <GroupsGrid GroupsList={visibleGroups} setUpdate={setUpdate} update={update}></GroupsGrid>
        ) : (
          <div style={{ display: "flex", width: "100%" }}>
          <DeviceLoadingGrid
            CardCount={20}
          />
        </div>
        )}
      </div>
    </>
  );
}

export default Groups

export async function loader() {
  const token = localStorage.getItem('token');
  const client = localStorage.getItem('client');

  const apiData = {
    token,
    client
  }

  return defer({
    groups: getGroups(apiData)
  })
}